import { createPaginator } from "@smithy/core";
import { ListProjectsCommand, } from "../commands/ListProjectsCommand";
import { EvidentlyClient } from "../EvidentlyClient";
export const paginateListProjects = createPaginator(EvidentlyClient, ListProjectsCommand, "nextToken", "nextToken", "maxResults");
